// Harita anahtarı: /api/meta/cities kaydını SVG'deki il yolunun
// data-city-name değeriyle eşleştiren slug.
//
// Sunucu slug döndürüyorsa o kullanılır; yoksa etiket slug'a çevrilir.
// İstanbul iki ayrı şehir olarak işletildiği için (istanbul-avrupa /
// istanbul-anadolu) haritada yalın "istanbul" yolu yoktur. Yaka ayrımı
// öncesinden kalan "İstanbul" etiketi (migration henüz çalışmamış sunucu,
// önbellekte kalan eski yanıt) Avrupa yakasına düşer; aksi hâlde iki yaka
// da haritada renksiz kalır.
import { slugify } from "./AltHomeUtils";

const ALIASES = {
  istanbul: "istanbul-avrupa",
  "istanbul-avrupa-yakasi": "istanbul-avrupa",
  "istanbul-anadolu-yakasi": "istanbul-anadolu",
  "istanbul-asya": "istanbul-anadolu",
  "istanbul-asya-yakasi": "istanbul-anadolu",
};

/** Etiket ya da slug → harita anahtarı ("İstanbul" → "istanbul-avrupa"). */
export const normalizeMapCityKey = (value) => {
  const raw = String(value ?? "").trim();
  if (!raw) return "";
  const base = raw.replace(/-\d+$/, "");
  // Hazır slug'lardaki tire boşluk sayılır ki slugify onu atmasın.
  const key = slugify(base.replace(/-/g, " "));
  return ALIASES[key] || key;
};

/** Meta şehir kaydı → harita anahtarı. Sunucunun verdiği slug önceliklidir. */
export const mapCityKeyOf = (city) =>
  normalizeMapCityKey(city?.slug || city?.label || city?.name);
